import { Grid } from '@mui/material';
import './TargetSelectionStep.css';
import TargetActivitiesTable from '../../../TargetActivitiesTable/TargetActivitiesTable';
import { useRequestdata } from '../../../useRequestData';
import { SuggestedSyllabus } from '../../../../../models/Syllabus';
import { useEffect, useState } from 'react';
import SourceInstitution from '../AcademicHistoryStep/SourceInstutition/SourceInstitution';

const TargetSelectionStep: React.FC = () => {
  const {
    target_syllabus: targetSyllabus,
    source_syllabus: sourceSyllabus,
    source_institution: sourceInstitution,
    targetInstitution,
    compatibleTargetSyllabuses,
    activities,
    sendDealData,
    dealId,
    setDealId,
    studentRecordsSyllabuses
  } = useRequestdata({});
  const requestData = useRequestdata({});
  const [optionsCompaibleSyllabuses, setOptionsCompatibleSyllabuses] = useState<SuggestedSyllabus[]>([]);
  const [dataSend, setDataSend] = useState(false)
  const [shouldFilter, setShouldFilter] = useState(true)
  const [savedStudentRecordsOptions, setSavedStudentRecordsOptions] = useState<SuggestedSyllabus[]>([])

  useEffect(() => {
    if (studentRecordsSyllabuses && studentRecordsSyllabuses.length > 0) {
      if (studentRecordsSyllabuses.some((sr) => sr.syllabus.institution?.id === targetInstitution?.id)) {
        const options = studentRecordsSyllabuses
          .filter(sr =>
            sr.syllabus.institution?.id === targetInstitution?.id &&
            sr.syllabus.id !== sourceSyllabus?.id
          )
          .map((sr) => {
            return {
              ...sr.syllabus
            }
          })
        setSavedStudentRecordsOptions(options)
        setOptionsCompatibleSyllabuses(options)
        if (options.some((syllabus) => syllabus.id === targetSyllabus?.id) || (!targetSyllabus && shouldFilter)) {
          setShouldFilter(true)
        } else {
          setShouldFilter(false)
        }
      } else {
        setShouldFilter(false)
      }
    } else {
      setShouldFilter(false)
    }
  }, [studentRecordsSyllabuses, targetSyllabus]);

  useEffect(() => {
    if (!shouldFilter) {
      if (compatibleTargetSyllabuses && compatibleTargetSyllabuses.length > 0 && sourceInstitution?.id !== targetInstitution?.id) {
        setOptionsCompatibleSyllabuses(compatibleTargetSyllabuses.map((syllabus) => {
          return {
            ...syllabus,
            id: syllabus.targetSyllabusId,
            name: syllabus.targetSyllabusName
          }
        }))
      } else {
        setOptionsCompatibleSyllabuses([]);
      }
    } else if (savedStudentRecordsOptions.length > 0) {
      setOptionsCompatibleSyllabuses(savedStudentRecordsOptions)
    }
  }, [compatibleTargetSyllabuses, shouldFilter, savedStudentRecordsOptions]);


  useEffect(() => {
    if (targetSyllabus !== null && dataSend === false) {
      sendDealData()
      setDataSend(true)
    }
  }, [targetSyllabus]);
  useEffect(() => {
    setDealId(dealId)
  }, [dealId]);


  return (
    <Grid container
        direction="column"
        alignContent={'center'}
        height={'auto'}
        className='REQXXI-Step-Container-Component'
        data-testid={'ActivitiesSelectionStep-Container'}
      >
        <Grid
          item
          height={'inherit'}
          width={'100%'}
          marginRight={0}
        >
          <Grid container
            justifyContent="space-between"
            height={'inherit'}
            wrap='nowrap'
            maxHeight={'600px'}
            className='REQXXI-Container-Component'>
            <Grid
              item xs={6}
              height={'inherit'}
              ml={1}
              mr={1}
              className='REQXXI-Grid-Paper'
            >
              <SourceInstitution requestData={useRequestdata({})} />
            </Grid>
            <Grid
              item xs={6}
              ml={1}
              mr={1}
              height={'inherit'}
              className='REQXXI-Bottom-Paper'
            >
              {sourceInstitution && sourceSyllabus && activities &&
                <TargetActivitiesTable
                  sourceInstitution={sourceInstitution}
                  sourceSyllabus={sourceSyllabus}
                  targetSyllabus={targetSyllabus}
                  activities={activities}
                  requestData={requestData}
                />}
            </Grid>
          </Grid>
        </Grid>
    </Grid >
  );
};

export default TargetSelectionStep;
